import { type FC, memo } from 'react';
// Asset imports - bundler handles path resolution
import closeIcon from '~/static/assets/icons/landing-page/close-icon.svg';
import type { ModalHeaderProps } from '../../types';
import UpdatingOverlay from '../shared/UpdatingOverlay';

const ModalHeader: FC<ModalHeaderProps> = ({
  totalMeetings,
  limit,
  isFreePlan,
  onClose,
  isUpdating,
}) => (
  <div className="personal-meetings-modal__header">
    <h2 className="personal-meetings-modal__title">
      Personal Meeting IDs
      {!isFreePlan && (
        <span className="personal-meetings-modal__title-count">
          {totalMeetings}/{limit}
        </span>
      )}
    </h2>
    <UpdatingOverlay isVisible={!!isUpdating} />
    <button
      type="button"
      onClick={onClose}
      className="personal-meetings-modal__header-close"
      aria-label="Close Personal Meeting modal"
    >
      <img src={closeIcon.src} width={closeIcon.width} height={closeIcon.height} alt="Close" />
    </button>
  </div>
);

export default memo(ModalHeader);
